<table class="table">
    <tbody>
        <ng-template #fieldComponent></ng-template>
    </tbody>
</table>